import React from 'react';
import { SectionHeading } from './SectionHeading';
import { steps } from '../../data/landing';
export function HowItWorks() {
  return <section aria-labelledby="how-title" className="bg-paper py-16 md:py-24" data-id="element-105" data-mp="lfamd26c8mn1">
      <div className="mx-auto max-w-6xl px-5" data-id="element-106" data-mp="7ncjva74tozu">
        <SectionHeading id="how-title" title={<>
              Así de simple: de la duda a la sesión <em className="text-primary" data-id="element-108" data-mp="3tv41bcl0tq1z">en minutos</em>
            </>} subtitle="Un mismo recorrido para cada sesión, sin buscar ni improvisar." data-id="element-107" data-mp="7mkvajbycrj2" />
        <ol className="relative mt-14 grid gap-8 md:grid-cols-5 md:gap-6" data-id="element-109" data-mp="2mya9npvu6zp">
          <span aria-hidden="true" className="absolute left-[10%] right-[10%] top-6 hidden h-px bg-line md:block" data-id="element-110" data-mp="3kwrzsfim97ur" />
          {steps.map((step, i) => <li key={step.title} className="relative flex gap-5 md:flex-col md:items-center md:gap-0 md:text-center" data-id="element-111" data-mp="1j3125o9fxzub" data-mpi={i}>
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-primary font-serif text-xl text-white ring-8 ring-paper" data-id="element-112" data-mp="1o1m2roslulja">
                {i + 1}
              </span>
              <div className="md:mt-5" data-id="element-113" data-mp="1byu6upf3o5pn">
                <h3 className="font-serif text-xl leading-tight text-ink" data-id="element-114" data-mp="1bxsu8gifrb5t">{step.title}</h3>
                <p className="mt-1.5 text-[15px] leading-snug text-muted" data-id="element-115" data-mp="1pt4n0id16rk3">{step.text}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}